import React, { forwardRef } from "react"
import Tippy from "@tippyjs/react"
import "tippy.js/dist/tippy.css"
import "tippy.js/themes/light-border.css"
const ButtonMaker = forwardRef(({text, className, onClick }, ref) => {
  return <button type="button" onClick={() => onClick()} className={"button " + className} ref={ref}>{text}</button>
})


const SearchFilterPopUp = props => {
  const { triggerText, triggerClassName, open, onClose, onOpen, children } = props

    return (
      <>
        <Tippy
          trigger="click"
          sticky={true}
          arrow={true}
          arrowType={"sharp"}
          hideOnClick={true}
          theme="light-border"
          animation={false}
          visible={open}
          onClickOutside={() => onClose()}
          interactive={true}
          placement={"bottom-start"}
          content={children}
          maxWidth={700}
          className={"search-filter-modal"}
          onMount={() => onOpen()}
          onHide={() => onClose()}
          appendTo={document.getElementById("search-filters-bar")}
        >
          <ButtonMaker
            text={triggerText}
            onClick={open ? () => onClose() : () => onOpen()}
            className={triggerClassName}
          />
        </Tippy>
      </>
    )
}

export default SearchFilterPopUp

SearchFilterPopUp.defaultProps = {
  trigger: null,
  open: false,
  onClose: () => {},
  onOpen: () => { },
  children: null
}
